var React = require('react');

function SliderArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5L2 10.5ZM110.061 13.0607C110.646 12.4749 110.646 11.5251 110.061 10.9393L100.515 1.39341C99.9289 0.80762 98.9792 0.80762 98.3934 1.39341C97.8076 1.97919 97.8076 2.92894 98.3934 3.51473L106.879 12L98.3934 20.4853C97.8076 21.0711 97.8076 22.0208 98.3934 22.6066C98.9792 23.1924 99.9289 23.1924 100.515 22.6066L110.061 13.0607ZM2 13.5L109 13.5L109 10.5L2 10.5L2 13.5Z"}));
}

SliderArrowInline.defaultProps = {"width":"111","height":"24","viewBox":"0 0 111 24","fill":"none"};

module.exports = SliderArrowInline;

SliderArrowInline.default = SliderArrowInline;
